module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTABQ2ABS2QBR2QBR2gBQ1wBR2ABQ0gBS2QBQ2gBR2ABR2QBS2WgTTMIAAAAMdFJOUwAg36DAQIoQ7zBkUBJYGIIAAACWSURBVAjXY2BABWGJMFbImTOmMNYRmzPeIJbImWYBRpszikBmTlsBAwOj0WEQ0wAkx3YMSKwxYGBSYGAGMx0KhRQFWE4BmXsUYs6cOcpyFMicA2YygZgyBxiFFMU5DgKZNcdB2niOA5k8ID5QDkiAVQF1AAmWM1YM7FvOOACZnD5nmjPOHJkAkmNMOnOmLQDm9FQ0vwAAENQrGcGTxFgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/prow1.png
// module id = C41M
// module chunks = 1